import * as api from '../services/ApiController'
import { createStore, combineReducers, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
// import logger from 'redux-logger'

import * as Reducers from './reducers'

const composeEnhancers = composeWithDevTools({})

export default createStore(
  combineReducers(Reducers),
  composeEnhancers(applyMiddleware(thunk.withExtraArgument(api)))
)



// WEBPACK FOOTER //
// ./src/store/index.js